import Status from "./status";

class SelectionSiteStatus extends Status {}

export default SelectionSiteStatus;
